'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "move-report-owner-modal" */'dashboard-components/js/report-actions/modals/MoveReportModal');
export default Loadable({
  loader,
  LoadingComponent: () => null
});